import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { HaebomLogoSolid } from '@/shared/ui/HaebomLogoSolid'
import { HamburgerIcon } from '@/shared/ui/icons/HamburgerIcon'
import { SidebarDrawer } from '@/shared/ui/SidebarDrawer'

export function HomeHeader({ title }: { title?: string } = {}) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header className="relative h-[46px]">
      {title !== undefined ? (
        <h1 className="absolute top-[9px] left-4 m-0 w-[309.383px] text-headline-xs font-semibold tracking-[-0.1px] text-black-800">{title}</h1>
      ) : (
        <NavLink
          to="/"
          className="absolute top-1/2 left-4 inline-flex -translate-y-1/2"
          aria-label="해봄 홈"
        >
          <HaebomLogoSolid height={28} />
        </NavLink>
      )}

      <button
        type="button"
        // 아이콘 버튼이라 누름 층이 **원형**이다 — 사각형이 24px 아이콘보다 커 보였다.
        className="ui-pressable ui-pressable--circle absolute top-[7px] right-2 flex h-8 w-8 cursor-pointer items-center justify-center border-0 bg-none p-0 text-black-600"
        aria-expanded={isOpen}
        aria-label="메뉴 열기"
        onClick={() => setIsOpen(true)}
      >
        <HamburgerIcon />
      </button>

      {isOpen && <SidebarDrawer onClose={() => setIsOpen(false)} />}
    </header>
  )
}
